// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { ProjectTypeIdEnum } from 'config/enums'
import { castToFloat } from 'helpers/reduxFormFunctions'
import { node, string } from 'prop-types'
import { useSelector } from 'react-redux'

const ProjectConfigWrapper = ({ children, sourceForm }) => {
  const projectTypeId = useSelector(state => state.form[sourceForm].values.projectTypeId)

  return (
    castToFloat(projectTypeId) !== ProjectTypeIdEnum.PROTECTION &&
    children
  )
}

ProjectConfigWrapper.propTypes = {
  children: node.isRequired,
  sourceForm: string.isRequired,
}

export default ProjectConfigWrapper
